export default function ArticleSearchResults({searchTerm, searchResults = [], total = null, limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {(searchResults || []).length > 0 &&
          <ul className="search-results__list">
            {(searchResults || []).slice(0, limit).map((result, index) =>
              <li className={"search-result search-result--" + (result.bundle?.system || '')} key={index}>
                <article className={"teaser teaser--sand-light"}>
                  <div className={"teaser__content"}>
                    <h3 className={"teaser__title"}>
                      <a href={result.link}>{result.title || ''}</a>
                    </h3>
                    <div className={"teaser__meta meta meta--last"}>
                      {result.meta?.district && (
                        <div className={"teaser__meta-item meta__item"}>{result.meta.district}</div>
                      )}
                      {result.meta?.theme && (
                        <div className={"teaser__meta-item meta__item"}>{result.meta.theme}</div>
                      )}
                      <div className={"teaser__meta-item meta__item meta__item--date"}>
                        {result.dates?.created?.formatted && (
                          <time dateTime={result.dates.created.iso || ''}>
                            {result.dates.created.formatted}
                          </time>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={"teaser__labels"}>
                    {result.meta?.label && (
                      <div className={"meta__item meta__item--label-light"}>
                        <span>{result.meta.label}</span>
                      </div>
                    )}
                  </div>
                  {result.file_url ? (
                    <div className={"teaser__image"}>
                      <img alt={result.title || ''} src={result.file_url} />
                    </div>
                  ) : (
                    <div className={"teaser__placeholder-image"}>
                      <div className={"teaser__placeholder-image__image"}>
                        {/*css inserts placeholder images */}
                      </div>
                    </div>
                  )}
                </article>
              </li>
            )}
          </ul>
        }
      </div>
    </>
  );
}
